import React from 'react';

const Crypto = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "21",
    height: "20",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.3625 1.78652C10.2934 1.62454 10.0638 1.62454 9.99462 1.78652L9.26855 3.48752C9.2403 3.55369 9.17869 3.59959 9.1072 3.60772L7.32761 3.81005C7.15896 3.82922 7.08936 4.03653 7.21227 4.15359L8.55247 5.43007C8.6021 5.47734 8.62407 5.54674 8.61068 5.61396L8.24222 7.46384C8.20828 7.63424 8.39283 7.7639 8.54163 7.67419L10.0753 6.74958C10.1388 6.71128 10.2183 6.71128 10.2818 6.74958L11.8155 7.67419C11.9643 7.7639 12.1488 7.63424 12.1149 7.46384L11.7464 5.61396C11.7331 5.54674 11.755 5.47734 11.8047 5.43007L13.1449 4.15359C13.2678 4.03653 13.1982 3.82922 13.0295 3.81005L11.2499 3.60772C11.1784 3.59959 11.1168 3.55369 11.0886 3.48752L10.3625 1.78652ZM8.19219 9.59204C7.80559 9.59204 7.49219 9.90544 7.49219 10.292V13.2324H3.82305C3.43645 13.2324 3.12305 13.5458 3.12305 13.9324V17.1727C3.12305 17.5593 3.43645 17.8727 3.82305 17.8727H7.79134C7.86108 17.8727 7.92843 17.8625 7.99199 17.8435C8.05542 17.8624 8.12262 17.8725 8.19219 17.8725H12.1605C12.2299 17.8725 12.2969 17.8624 12.3602 17.8436C12.4236 17.8625 12.4907 17.8726 12.5602 17.8726H16.5285C16.9151 17.8726 17.2285 17.5592 17.2285 17.1726V11.7482C17.2285 11.3616 16.9151 11.0482 16.5285 11.0482H12.8605V10.292C12.8605 9.90544 12.5471 9.59204 12.1605 9.59204H8.19219ZM11.8602 11.7482L11.8605 11.7291V10.592H8.49219V16.8725H11.8602V11.7482ZM16.2285 16.8726H12.8605V12.0482H16.2285V16.8726ZM4.12305 16.8727V14.2324H7.49134V16.8727H4.12305Z",
      fill: "white"
    }
  )
);

export { Crypto };
//# sourceMappingURL=Crypto.js.map
